import { Component, OnInit } from '@angular/core';
import { Direction } from 'src/app/constants/global-constants';
import { IBlog } from 'src/app/models/dashboard.models';
import { DashboardService } from 'src/app/services/dashboard.service';
import { HomeService } from 'src/app/services/home.service';
import { MediaMatcher } from '@angular/cdk/layout';

@Component({
  selector: 'app-blogs',
  templateUrl: './blogs.component.html',
  styleUrls: ['./blogs.component.scss']
})
export class BlogsComponent implements OnInit {

  offset: number = 0;
  limit: number = 5;
  blogs: Array<IBlog> = [];
  selectedBlogIndex: number;
  direction = Direction;
  loading: boolean = true;
  
  constructor(public homeService: HomeService,
    public dashboardService: DashboardService,
    public mediaMatcher: MediaMatcher) { }

  ngOnInit(): void {
    this.getBlogs();
  }

  getBlogs(){
    this.homeService.getRecentBlogs(this.limit, this.offset)
    .subscribe((res)=>{
      console.log("Home/Blogs: ",res);
      this.blogs = res.payload;
      this.selectedBlogIndex = 0;
      this.truncateBlogBody();
      this.loading = false;
    },err=>{
      console.error("Home/Blogs Error: ",err);
    });
  }

  truncateBlogBody(){
    const view = this.mediaMatcher.matchMedia('(min-width: 767px)').matches;
    this.blogs.forEach(blog =>{
      blog.body = blog.body.substring(0, view ? 800 : 300) + ' ...';
    });
  }

  navigateBlog(navigate: string){
    if(navigate == this.direction.DECREMENT && this.selectedBlogIndex != 0)
    {
      this.selectedBlogIndex = this.selectedBlogIndex - 1;
    }
    if(navigate == this.direction.INCREMENT && this.selectedBlogIndex != this.blogs.length - 1)
    {
      this.selectedBlogIndex = this.selectedBlogIndex + 1;
    }
  }
}
